import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Distribution from './pages/Distribution';
import ViyaCrab from './pages/ViyaCrab';
import GoldenSheaf from './pages/GoldenSheaf';
import Trading from './pages/Trading';
import Contact from './pages/Contact';
import Terms from './pages/Terms';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/distribution" element={<Distribution />} />
              <Route path="/distribution/viya-crab" element={<ViyaCrab />} />
              <Route path="/distribution/golden-sheaf" element={<GoldenSheaf />} />
              <Route path="/trading" element={<Trading />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;